var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCcm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FFF9DD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE777",
    d: "M38.876 24h-11.25A2.627 2.627 0 0 0 25 26.626v6.75A2.628 2.628 0 0 0 27.626 36h11.25a2.628 2.628 0 0 0 2.625-2.625v-6.75A2.63 2.63 0 0 0 38.876 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M58.374 24h-11.25a2.628 2.628 0 0 0-2.625 2.626v15.75A2.628 2.628 0 0 0 47.124 45h11.25A2.628 2.628 0 0 0 61 42.376v-15.75A2.627 2.627 0 0 0 58.374 24zM38.876 39h-11.25A2.627 2.627 0 0 0 25 41.625v15.75A2.627 2.627 0 0 0 27.626 60h11.25a2.628 2.628 0 0 0 2.625-2.626v-15.75a2.63 2.63 0 0 0-2.625-2.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE777",
    d: "M58.374 48h-11.25a2.628 2.628 0 0 0-2.625 2.626v6.75a2.628 2.628 0 0 0 2.625 2.626h11.25A2.63 2.63 0 0 0 61 57.374v-6.75a2.627 2.627 0 0 0-2.626-2.623z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCcm);
export default __webpack_public_path__ + "static/media/ic-ccm.d9d6d67c5d61c464ec8bbfc1cf08587b.svg";
export { ForwardRef as ReactComponent };